import { JointTrackPublication } from "@/types/call";
import { RemoteTrackPublication } from "twilio-video";

export const getIsRemoteTrackPublication = (
  publication: JointTrackPublication,
): publication is RemoteTrackPublication =>
  publication.hasOwnProperty("isSubscribed");
